import React, { useState, useEffect } from "react";
import styles from "../../styles.module.scss";
import { IoMdShare, IoMdClose } from "react-icons/io";
import { FaLine } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import clsx from "clsx";

export default function ShareButton({
  className,
  ref,
}: {
  className?: string;
  ref: React.RefObject<HTMLDivElement | null>;
}) {
  const [showMenu, setShowMenu] = useState(false);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showMenu]);

  function handleShareLine() {
    if (!ref || !ref.current) return;
    
    const text = ref.current.innerText;
    const lineUrl = `https://line.me/R/msg/text/?${encodeURIComponent(text)}`;
    window.open(lineUrl, '_blank', 'noopener,noreferrer');
    setShowMenu(false);
  }

  function handleShareGmail() {
    if (!ref || !ref.current) return;
    
    const text = ref.current.innerText;
    const subject = "チャットボットからの共有";
    const gmailUrl = `https://mail.google.com/mail/?view=cm&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`;
    window.open(gmailUrl, '_blank', 'noopener,noreferrer');
    setShowMenu(false);
  }

  return (
    <>
      <div className={clsx(styles._onetouchai_buttonWrap, className)}>
        <button
          type="button"
          onClick={() => setShowMenu(true)}
          className={clsx(styles._onetouchai_toolButton, className)}
        >
          <IoMdShare className={styles._onetouchai_icon} aria-label="共有" />
        </button>
      </div>
      
      {showMenu && (
        <>
          <div 
            className={styles._onetouchai_shareBackdrop}
            onClick={() => setShowMenu(false)}
          />
          <div className={styles._onetouchai_shareBottomSheet}>
            <div className={styles._onetouchai_shareSheetHeader}>
              <h3>共有</h3>
              <button
                type="button"
                onClick={() => setShowMenu(false)}
                className={styles._onetouchai_shareCloseBtn}
              >
                <IoMdClose />
              </button>
            </div>
            <div className={styles._onetouchai_shareSheetContent}>
              <button
                type="button"
                className={styles._onetouchai_shareSheetItem}
                onClick={handleShareLine}
              >
                <div className={styles._onetouchai_shareIconWrapper}>
                  <FaLine style={{ color: "#00B900", fontSize: "24px" }} />
                </div>
                <span>LINE</span>
              </button>
              <button
                type="button"
                className={styles._onetouchai_shareSheetItem}
                onClick={handleShareGmail}
              >
                <div className={styles._onetouchai_shareIconWrapper}>
                  <SiGmail style={{ color: "#EA4335", fontSize: "22px" }} />
                </div>
                <span>Gmail</span>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
